module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/images/direction-A-lvl2-75.a3983b93.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/images/direction-A-lvl2-75.png
// module id = 3373
// module chunks = 11